import { Loading } from "element-ui";
import { Base64 } from "js-base64";

export default {
  // 公用函数
  dateFormat: function (date, fmt) {
    if (!(date instanceof Date)) {
      date = new Date(date);
    }
    var o = {
      "M+": date.getMonth() + 1,
      "d+": date.getDate(),
      "H+": date.getHours(),
      "m+": date.getMinutes(),
      "s+": date.getSeconds(),
      "q+": Math.floor((date.getMonth() + 3) / 3),
      S: date.getMilliseconds(),
    };
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (let k in o) {
      if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
    }
    return fmt;
  },
  getWeek: function (tmp) {
    switch (tmp) {
      case 7:
        return "星期日";
      case 1:
        return "星期一";
      case 2:
        return "星期二";
      case 3:
        return "星期三";
      case 4:
        return "星期四";
      case 5:
        return "星期五";
      case 6:
        return "星期六";
    }
  },
  showLoading: function (element, text = "") {
    const option = {
      lock: true,
      text: text,
      background: "rgba(0, 0, 0, 0.1)",
      customClass: "loading",
    };
    if (element) {
      option.target = element;
    }
    return Loading.service(option);
  },
  closeLoading: function (instance) {
    setTimeout(() => {
      if (!instance) {
        Loading.service().close();
      } else {
        instance.close();
      }
    }, 0);
  },
  openWindow: function (path, name) {
    window.open(`/#/${path}`, name, "toolbar =no, menubar=no, scrollbars=no, resizable=no, location=no, status=no");
  },
  timerInClock: function (callback, every = 0, time = 3) {
    // 每小时的0分钟调用一次
    let hour = new Date().getHours();
    let minute = new Date().getMinutes();
    return setInterval(() => {
      if ((!every && new Date().getMinutes() === 0 && new Date().getHours() !== hour) || (every && new Date().getMinutes() % every === 0 && new Date().getMinutes() !== minute)) {
        hour = new Date().getHours();
        minute = new Date().getMinutes();
        callback && callback(this.getTime());
      }
    }, time * 1000);
  },
  timerInDay: function (callback, time = 10) {
    let today = new Date().getDate();
    return setInterval(() => {
      if (new Date().getHours() === 0 && new Date().getDate() !== today) {
        today = new Date().getDate();
        callback && callback(this.getTime());
      }
    }, time * 1000);
  },
  getTime: function () {
    const today = new Date();
    return (today.getHours() < 10 ? `0${today.getHours()}` : today.getHours()) + ":" + (today.getMinutes() < 10 ? `0${today.getMinutes()}` : today.getMinutes());
  },
  getIconZh: function (txt) {
    if (txt.includes("雨")) {
      return require("../images/weather/zy.png");
    } else if (txt.includes("雾")) {
      return require("../images/weather/w.png");
    } else if (txt.includes("雪")) {
      return require("../images/weather/dx.png");
    } else if (txt.includes("云") || txt.includes("阴")) {
      return require("../images/weather/yt.png");
    } else {
      return require("../images/weather/dy.png");
    }
  },
  getIcon: function (code) {
    code = typeof code === "string" ? parseInt(code) : code;
    switch (code) {
      case 100:
      case 900:
        return require("../images/weather/qt.png");
      case 101:
      case 102:
      case 103:
      case 999:
        return require("../images/weather/dy.png");
      case 104:
      case 901:
        return require("../images/weather/yt.png");
      case 200:
      case 201:
      case 202:
      case 203:
      case 204:
      case 205:
      case 206:
      case 207:
      case 208:
      case 209:
      case 210:
      case 211:
      case 212:
      case 213:
        return require("../images/weather/tf.png");
      case 507:
      case 508:
        return require("../images/weather/scb.png");
      case 300:
      case 301:
      case 302:
      case 303:
      case 304:
        return require("../images/weather/lzy.png");
      case 305:
        return require("../images/weather/xy.png");
      case 306:
      case 399:
      case 314:
        return require("../images/weather/zy.png");
      case 307:
      case 308:
      case 309:
      case 315:
        return require("../images/weather/dy.png");
      case 310:
      case 311:
      case 312:
      case 313:
      case 316:
      case 317:
      case 318:
        return require("../images/weather/by.png");
      case 400:
        return require("../images/weather/xx.png");
      case 401:
      case 499:
      case 408:
        return require("../images/weather/zx.png");
      case 402:
      case 407:
      case 409:
        return require("../images/weather/dx.png");
      case 403:
      case 410:
        return require("../images/weather/bx.png");
      case 404:
      case 405:
      case 406:
        return require("../images/weather/yjx.png");
      case 500:
      case 501:
      case 509:
      case 510:
      case 514:
      case 515:
        return require("../images/weather/w.png");
      case 502:
      case 503:
      case 504:
      case 511:
      case 512:
      case 513:
        return require("../images/weather/wm.png");
      default:
        return require("../images/weather/dy.png");
    }
  },
  getDateOfStart: function (date) {
    const date1 = date || new Date();
    let start = date1.setDate(date1.getDate() - (date1.getDay() || 7) + 1);
    return new Date(this.dateFormat(start, "yyyy/MM/dd 00:00:00"));
  },
  htmlFormat: function (html) {
    let text = html;
    text = text.replace(/(\n)/g, "");
    text = text.replace(/(\t)/g, "");
    text = text.replace(/(\r)/g, "");
    text = text.replace(/<\/?[^>]*>/g, "");
    text = text.replace(/\s*/g, "");
    text = text.replace(/&nbsp;*/g, "");
    return text;
  },
  containObject: function (a, b) {
    // 判断a对象是否包含b对象(k和v都需要一致)
    let result = true;
    for (const key in b) {
      // 如果a中有b的key并且
      if (Object.keys(a).includes(key)) {
        if (typeof b[key] === "object" && !Array.isArray(b[key])) {
          result = this.containObject(a[key], b[key]);
        } else {
          if (Array.isArray(b[key])) {
            // 如果是数组的话
            result = b[key].join("") === a[key].join("");
          } else if (b[key] && typeof b[key] === "string" && (b[key].indexOf("p1") > -1 || b[key].indexOf("p2") > -1)) {
            // 窗帘的指令，做兼容性判断
            const jr = {
              up: ["pl_p2,h1", "p1_p2,v1", "p1_p2,p1"],
              down: ["pl_p2,h2", "p1_p2,v2", "p1_p2,p2"],
            };
            if ((jr.up.includes(a[key]) && jr.up.includes(b[key])) || (jr.down.includes(a[key]) && jr.down.includes(b[key]))) {
              result = true;
            }
          } else {
            result = b[key] === a[key];
          }
        }
        if (!result) {
          break;
        }
      } else {
        result = false;
        break;
      }
    }
    return result;
  },
  resolveQuery: function () {
    try {
      const url = decodeURIComponent(Base64.decode(decodeURIComponent(window.location.hash.split("?")[1])));
      const arr = url.split("&");
      const obj = {};
      arr.forEach((p) => {
        const kv = p.split("=");
        obj[kv[0]] = kv[1];
      });
      return obj;
    } catch (e) {
      return {};
    }
  },
};
